import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import AppProvider from 'App/AppProvider'

ReactDOM.render(<AppProvider />, document.getElementById('root'))
